import { render } from "./BindMobile.vue?vue&type=template&id=96f2e032&scoped=true"
import script from "./BindMobile.vue?vue&type=script&lang=js"
export * from "./BindMobile.vue?vue&type=script&lang=js"

import "./BindMobile.vue?vue&type=style&index=0&id=96f2e032&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f2e032"]])

export default __exports__